import { IconSvg, IconSvgProps } from "./icon"

export default function Trash(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M4.5 7.625h15m-10.625 0V7a3.125 3.125 0 1 1 6.25 0v.625m-5 2.5V17m3.75-6.875V17m-7.5-9.375h11.25v11.25a1.25 1.25 0 0 1-1.25 1.25h-8.75a1.25 1.25 0 0 1-1.25-1.25V7.625Z" />
    </IconSvg>
  )
}
